import { render, staticRenderFns } from "./AchievementNew.vue?vue&type=template&id=0b279888&scoped=true&"
import script from "./AchievementNew.vue?vue&type=script&lang=js&"
export * from "./AchievementNew.vue?vue&type=script&lang=js&"
import style0 from "./AchievementNew.vue?vue&type=style&index=0&id=0b279888&scoped=true&lang=scss&"
import style1 from "./AchievementNew.vue?vue&type=style&index=1&id=0b279888&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b279888",
  null
  
)

export default component.exports